var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('list-page-shell',{attrs:{"title":"审核中"}},[_c('order-workbench',{attrs:{"show-title":false,"show-announcement-columns":false,"hide-primary-actions":true,"show-create-button":false,"extra-query-params":{ review_list: 1 }}})],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-675b8520","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/views/ReviewList.vue
// module id = V9+9
// module chunks = 0